export default {
  readon: '继续阅读',
  learnmore: '了解更多',
  submit: '发送',
  filter: '筛选结果',
  cancel: '取消',
  apply: '套用',
  compver: '对照不同版本',
  show: '显示',
  back: '返回',
  prev_page: '上一页',
  all: '全部',
  close: '关闭',
  goto: '前往',
  howto: '如何',
  print: '列印此文件',
  advagain: '再次进阶搜寻',
  use: '进行',
  togglehl: '切换搜索词高亮显示',
  next: '下一项',
  prev: '上一项',
  collapse: '收起',
  showall: '显示全部',
  checkcontent: '完整显示全部内容',
  showless: ' 显示较少',
  shortcut: '快速链接',
  search: "搜索",
  contactus: '联系我们',
  donate: '捐款',
  feedback: '递交意见',
  selectall: "全选",
  deselect: "全部取消",
  reset_form: "重设表格",
  case_showalltitle: '显示全部名称',
  case_collapsetitle: '收起部分名称',
  ft_support: '支持 HKLII',
  ft_legal: '政策及条款',
  ft_link: '链接',
  ft_disclaimer: '免责声明',
  ft_donors: '捐款人',
  ft_home: '主页',
  hd_liis: '其他 LII',
  classic: '经典',
  news: '新功能简介',
  newfeature: '新功能',
}